import React, { createContext, useState, useContext, useEffect } from 'react';

// Thèmes — Light mode 'impulse' par défaut (violet #a591ef sur blanc #ffffff) — branded QLICKR
export const themes = {
  impulse: {
    name: 'QLICKR Light',
    primary: '#a591ef',
    secondary: '#8b74e0',
    accent: '#c4b5fd',
    background: '#ffffff',
    surface: '#f8f7ff',
    surfaceHover: '#f0eeff',
    border: '#e8e5f5',
    text: '#a591ef',
    textPrimary: '#6b5bb5',
    textSecondary: '#8b7fc7',
    textMuted: '#b8aee0',
    textDark: '#4a3d8f',
    cardBg: '#ffffff',
    cardBorder: '#e8e5f5',
    sidebarBg: '#f8f7ff',
    sidebarActive: '#a591ef',
    sidebarText: '#8b7fc7',
    inputBg: '#ffffff',
    inputBorder: '#e0ddf0',
    inputFocus: '#a591ef',
    buttonPrimary: '#a591ef',
    buttonPrimaryHover: '#8b74e0',
    buttonSecondary: '#f0eeff',
    buttonText: '#ffffff',
    success: '#7cc88e',
    warning: '#e8b84a',
    error: '#e87272',
    info: '#72b8e8',
    gradient: 'linear-gradient(135deg, #a591ef, #c4b5fd)',
    shadow: '0 2px 8px rgba(165, 145, 239, 0.12)',
    shadowHover: '0 4px 16px rgba(165, 145, 239, 0.2)',
    isDark: false
  },
  default: {
    name: 'Dark+ (default)',
    primary: '#8B5CF6',
    secondary: '#A855F7',
    accent: '#C084FC',
    background: '#1e1f22',
    surface: '#2b2d31',
    surfaceHover: '#35373c',
    border: '#3f4147',
    text: '#ffffff',
    textPrimary: '#ffffff',
    textSecondary: '#b5bac1',
    textMuted: '#949ba4',
    textDark: '#ffffff',
    cardBg: '#2b2d31',
    cardBorder: '#3f4147',
    sidebarBg: '#1e1f22',
    sidebarActive: '#8B5CF6',
    sidebarText: '#949ba4',
    inputBg: '#1e1f22',
    inputBorder: '#3f4147',
    inputFocus: '#8B5CF6',
    buttonPrimary: '#8B5CF6',
    buttonPrimaryHover: '#7c3aed',
    buttonSecondary: '#3f4147',
    buttonText: '#ffffff',
    success: '#248046',
    warning: '#fbbf24',
    error: '#ff4444',
    info: '#5b9bd5',
    gradient: 'linear-gradient(135deg, #8B5CF6, #A855F7)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  monokai: {
    name: 'Monokai',
    primary: '#F92672',
    secondary: '#FD971F',
    accent: '#A6E22E',
    background: '#272822',
    surface: '#3E3D32',
    surfaceHover: '#4a493e',
    border: '#49483E',
    text: '#F8F8F2',
    textPrimary: '#F8F8F2',
    textSecondary: '#CFCFC2',
    textMuted: '#75715E',
    textDark: '#F8F8F2',
    cardBg: '#3E3D32',
    cardBorder: '#49483E',
    sidebarBg: '#272822',
    sidebarActive: '#F92672',
    sidebarText: '#75715E',
    inputBg: '#272822',
    inputBorder: '#49483E',
    inputFocus: '#F92672',
    buttonPrimary: '#F92672',
    buttonPrimaryHover: '#e01f65',
    buttonSecondary: '#49483E',
    buttonText: '#F8F8F2',
    success: '#A6E22E',
    warning: '#E6DB74',
    error: '#F92672',
    info: '#66D9EF',
    gradient: 'linear-gradient(135deg, #F92672, #FD971F)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  dracula: {
    name: 'Dracula',
    primary: '#BD93F9',
    secondary: '#FF79C6',
    accent: '#8BE9FD',
    background: '#282A36',
    surface: '#44475A',
    surfaceHover: '#505370',
    border: '#6272A4',
    text: '#F8F8F2',
    textPrimary: '#F8F8F2',
    textSecondary: '#BFBFBF',
    textMuted: '#6272A4',
    textDark: '#F8F8F2',
    cardBg: '#44475A',
    cardBorder: '#6272A4',
    sidebarBg: '#282A36',
    sidebarActive: '#BD93F9',
    sidebarText: '#6272A4',
    inputBg: '#282A36',
    inputBorder: '#6272A4',
    inputFocus: '#BD93F9',
    buttonPrimary: '#BD93F9',
    buttonPrimaryHover: '#a77bf5',
    buttonSecondary: '#6272A4',
    buttonText: '#F8F8F2',
    success: '#50FA7B',
    warning: '#F1FA8C',
    error: '#FF5555',
    info: '#8BE9FD',
    gradient: 'linear-gradient(135deg, #BD93F9, #FF79C6)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  nord: {
    name: 'Nord',
    primary: '#88C0D0',
    secondary: '#81A1C1',
    accent: '#5E81AC',
    background: '#2E3440',
    surface: '#3B4252',
    surfaceHover: '#454d60',
    border: '#4C566A',
    text: '#ECEFF4',
    textPrimary: '#ECEFF4',
    textSecondary: '#D8DEE9',
    textMuted: '#616E88',
    textDark: '#ECEFF4',
    cardBg: '#3B4252',
    cardBorder: '#4C566A',
    sidebarBg: '#2E3440',
    sidebarActive: '#88C0D0',
    sidebarText: '#616E88',
    inputBg: '#2E3440',
    inputBorder: '#4C566A',
    inputFocus: '#88C0D0',
    buttonPrimary: '#88C0D0',
    buttonPrimaryHover: '#7ab4c5',
    buttonSecondary: '#4C566A',
    buttonText: '#ECEFF4',
    success: '#A3BE8C',
    warning: '#EBCB8B',
    error: '#BF616A',
    info: '#88C0D0',
    gradient: 'linear-gradient(135deg, #88C0D0, #81A1C1)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  oneDarkPro: {
    name: 'One Dark Pro',
    primary: '#61AFEF',
    secondary: '#C678DD',
    accent: '#E5C07B',
    background: '#282C34',
    surface: '#21252B',
    surfaceHover: '#2C313A',
    border: '#3E4451',
    text: '#ABB2BF',
    textPrimary: '#ABB2BF',
    textSecondary: '#9DA5B4',
    textMuted: '#5C6370',
    textDark: '#ABB2BF',
    cardBg: '#21252B',
    cardBorder: '#3E4451',
    sidebarBg: '#21252B',
    sidebarActive: '#61AFEF',
    sidebarText: '#5C6370',
    inputBg: '#1B1D23',
    inputBorder: '#3E4451',
    inputFocus: '#61AFEF',
    buttonPrimary: '#61AFEF',
    buttonPrimaryHover: '#528bcc',
    buttonSecondary: '#3E4451',
    buttonText: '#ffffff',
    success: '#98C379',
    warning: '#E5C07B',
    error: '#E06C75',
    info: '#61AFEF',
    gradient: 'linear-gradient(135deg, #61AFEF, #C678DD)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  githubDark: {
    name: 'GitHub Dark',
    primary: '#58A6FF',
    secondary: '#BC8CFF',
    accent: '#79C0FF',
    background: '#0D1117',
    surface: '#161B22',
    surfaceHover: '#1C2128',
    border: '#30363D',
    text: '#C9D1D9',
    textPrimary: '#C9D1D9',
    textSecondary: '#8B949E',
    textMuted: '#484F58',
    textDark: '#C9D1D9',
    cardBg: '#161B22',
    cardBorder: '#30363D',
    sidebarBg: '#0D1117',
    sidebarActive: '#58A6FF',
    sidebarText: '#484F58',
    inputBg: '#0D1117',
    inputBorder: '#30363D',
    inputFocus: '#58A6FF',
    buttonPrimary: '#238636',
    buttonPrimaryHover: '#2EA043',
    buttonSecondary: '#30363D',
    buttonText: '#ffffff',
    success: '#3FB950',
    warning: '#D29922',
    error: '#F85149',
    info: '#58A6FF',
    gradient: 'linear-gradient(135deg, #58A6FF, #BC8CFF)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.5)',
    isDark: true
  },
  githubLight: {
    name: 'GitHub Light',
    primary: '#0969DA',
    secondary: '#8250DF',
    accent: '#0550AE',
    background: '#ffffff',
    surface: '#F6F8FA',
    surfaceHover: '#EAEEF2',
    border: '#D0D7DE',
    text: '#1F2328',
    textPrimary: '#1F2328',
    textSecondary: '#656D76',
    textMuted: '#8C959F',
    textDark: '#1F2328',
    cardBg: '#ffffff',
    cardBorder: '#D0D7DE',
    sidebarBg: '#F6F8FA',
    sidebarActive: '#0969DA',
    sidebarText: '#656D76',
    inputBg: '#ffffff',
    inputBorder: '#D0D7DE',
    inputFocus: '#0969DA',
    buttonPrimary: '#2DA44E',
    buttonPrimaryHover: '#218838',
    buttonSecondary: '#EAEEF2',
    buttonText: '#ffffff',
    success: '#1A7F37',
    warning: '#9A6700',
    error: '#CF222E',
    info: '#0969DA',
    gradient: 'linear-gradient(135deg, #0969DA, #8250DF)',
    shadow: '0 2px 8px rgba(31, 35, 40, 0.08)',
    shadowHover: '0 4px 16px rgba(31, 35, 40, 0.12)',
    isDark: false
  },
  solarizedDark: {
    name: 'Solarized Dark',
    primary: '#268BD2',
    secondary: '#2AA198',
    accent: '#B58900',
    background: '#002B36',
    surface: '#073642',
    surfaceHover: '#0a4050',
    border: '#094959',
    text: '#839496',
    textPrimary: '#93A1A1',
    textSecondary: '#839496',
    textMuted: '#586E75',
    textDark: '#93A1A1',
    cardBg: '#073642',
    cardBorder: '#094959',
    sidebarBg: '#002B36',
    sidebarActive: '#268BD2',
    sidebarText: '#586E75',
    inputBg: '#002B36',
    inputBorder: '#094959',
    inputFocus: '#268BD2',
    buttonPrimary: '#268BD2',
    buttonPrimaryHover: '#1a7abc',
    buttonSecondary: '#094959',
    buttonText: '#FDF6E3',
    success: '#859900',
    warning: '#B58900',
    error: '#DC322F',
    info: '#268BD2',
    gradient: 'linear-gradient(135deg, #268BD2, #2AA198)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.5)',
    isDark: true
  },
  solarizedLight: {
    name: 'Solarized Light',
    primary: '#268BD2',
    secondary: '#2AA198',
    accent: '#B58900',
    background: '#FDF6E3',
    surface: '#EEE8D5',
    surfaceHover: '#E6DFCB',
    border: '#D6D0BC',
    text: '#657B83',
    textPrimary: '#586E75',
    textSecondary: '#657B83',
    textMuted: '#93A1A1',
    textDark: '#073642',
    cardBg: '#FDF6E3',
    cardBorder: '#D6D0BC',
    sidebarBg: '#EEE8D5',
    sidebarActive: '#268BD2',
    sidebarText: '#93A1A1',
    inputBg: '#FDF6E3',
    inputBorder: '#D6D0BC',
    inputFocus: '#268BD2',
    buttonPrimary: '#268BD2',
    buttonPrimaryHover: '#1a7abc',
    buttonSecondary: '#EEE8D5',
    buttonText: '#FDF6E3',
    success: '#859900',
    warning: '#B58900',
    error: '#DC322F',
    info: '#268BD2',
    gradient: 'linear-gradient(135deg, #268BD2, #2AA198)',
    shadow: '0 2px 8px rgba(101, 123, 131, 0.1)',
    shadowHover: '0 4px 16px rgba(101, 123, 131, 0.15)',
    isDark: false
  },
  catppuccinMocha: {
    name: 'Catppuccin Mocha',
    primary: '#CBA6F7',
    secondary: '#F5C2E7',
    accent: '#F38BA8',
    background: '#1E1E2E',
    surface: '#313244',
    surfaceHover: '#3b3c50',
    border: '#45475A',
    text: '#CDD6F4',
    textPrimary: '#CDD6F4',
    textSecondary: '#BAC2DE',
    textMuted: '#6C7086',
    textDark: '#CDD6F4',
    cardBg: '#313244',
    cardBorder: '#45475A',
    sidebarBg: '#1E1E2E',
    sidebarActive: '#CBA6F7',
    sidebarText: '#6C7086',
    inputBg: '#1E1E2E',
    inputBorder: '#45475A',
    inputFocus: '#CBA6F7',
    buttonPrimary: '#CBA6F7',
    buttonPrimaryHover: '#b48ef0',
    buttonSecondary: '#45475A',
    buttonText: '#1E1E2E',
    success: '#A6E3A1',
    warning: '#F9E2AF',
    error: '#F38BA8',
    info: '#89DCEB',
    gradient: 'linear-gradient(135deg, #CBA6F7, #F5C2E7)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  catppuccinLatte: {
    name: 'Catppuccin Latte',
    primary: '#8839EF',
    secondary: '#EA76CB',
    accent: '#E64553',
    background: '#EFF1F5',
    surface: '#E6E9EF',
    surfaceHover: '#DCE0E8',
    border: '#CCD0DA',
    text: '#4C4F69',
    textPrimary: '#4C4F69',
    textSecondary: '#5C5F77',
    textMuted: '#9CA0B0',
    textDark: '#4C4F69',
    cardBg: '#EFF1F5',
    cardBorder: '#CCD0DA',
    sidebarBg: '#E6E9EF',
    sidebarActive: '#8839EF',
    sidebarText: '#9CA0B0',
    inputBg: '#EFF1F5',
    inputBorder: '#CCD0DA',
    inputFocus: '#8839EF',
    buttonPrimary: '#8839EF',
    buttonPrimaryHover: '#7528d4',
    buttonSecondary: '#DCE0E8',
    buttonText: '#ffffff',
    success: '#40A02B',
    warning: '#DF8E1D',
    error: '#D20F39',
    info: '#1E66F5',
    gradient: 'linear-gradient(135deg, #8839EF, #EA76CB)',
    shadow: '0 2px 8px rgba(76, 79, 105, 0.08)',
    shadowHover: '0 4px 16px rgba(76, 79, 105, 0.12)',
    isDark: false
  },
  synthwave84: {
    name: "Synthwave '84",
    primary: '#FF7EDB',
    secondary: '#36F9F6',
    accent: '#FEDE5D',
    background: '#262335',
    surface: '#2a2139',
    surfaceHover: '#342b45',
    border: '#495495',
    text: '#FFFFFF',
    textPrimary: '#FFFFFF',
    textSecondary: '#BBB8D0',
    textMuted: '#848BBD',
    textDark: '#FFFFFF',
    cardBg: '#2a2139',
    cardBorder: '#495495',
    sidebarBg: '#262335',
    sidebarActive: '#FF7EDB',
    sidebarText: '#848BBD',
    inputBg: '#262335',
    inputBorder: '#495495',
    inputFocus: '#FF7EDB',
    buttonPrimary: '#FF7EDB',
    buttonPrimaryHover: '#e06bc5',
    buttonSecondary: '#495495',
    buttonText: '#ffffff',
    success: '#72F1B8',
    warning: '#FEDE5D',
    error: '#FE4450',
    info: '#36F9F6',
    gradient: 'linear-gradient(135deg, #FF7EDB, #36F9F6)',
    shadow: '0 2px 8px rgba(255, 126, 219, 0.2)',
    shadowHover: '0 4px 16px rgba(255, 126, 219, 0.3)',
    isDark: true
  },
  tokyoNight: {
    name: 'Tokyo Night',
    primary: '#7AA2F7',
    secondary: '#BB9AF7',
    accent: '#7DCFFF',
    background: '#1A1B26',
    surface: '#24283B',
    surfaceHover: '#2a2e42',
    border: '#3B4261',
    text: '#C0CAF5',
    textPrimary: '#C0CAF5',
    textSecondary: '#A9B1D6',
    textMuted: '#565F89',
    textDark: '#C0CAF5',
    cardBg: '#24283B',
    cardBorder: '#3B4261',
    sidebarBg: '#1A1B26',
    sidebarActive: '#7AA2F7',
    sidebarText: '#565F89',
    inputBg: '#1A1B26',
    inputBorder: '#3B4261',
    inputFocus: '#7AA2F7',
    buttonPrimary: '#7AA2F7',
    buttonPrimaryHover: '#6690e0',
    buttonSecondary: '#3B4261',
    buttonText: '#1A1B26',
    success: '#9ECE6A',
    warning: '#E0AF68',
    error: '#F7768E',
    info: '#7DCFFF',
    gradient: 'linear-gradient(135deg, #7AA2F7, #BB9AF7)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.35)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.45)',
    isDark: true
  },
  gruvboxDark: {
    name: 'Gruvbox Dark',
    primary: '#FE8019',
    secondary: '#FABD2F',
    accent: '#B8BB26',
    background: '#282828',
    surface: '#3C3836',
    surfaceHover: '#504945',
    border: '#504945',
    text: '#EBDBB2',
    textPrimary: '#EBDBB2',
    textSecondary: '#D5C4A1',
    textMuted: '#928374',
    textDark: '#EBDBB2',
    cardBg: '#3C3836',
    cardBorder: '#504945',
    sidebarBg: '#282828',
    sidebarActive: '#FE8019',
    sidebarText: '#928374',
    inputBg: '#282828',
    inputBorder: '#504945',
    inputFocus: '#FE8019',
    buttonPrimary: '#FE8019',
    buttonPrimaryHover: '#e06f10',
    buttonSecondary: '#504945',
    buttonText: '#282828',
    success: '#B8BB26',
    warning: '#FABD2F',
    error: '#FB4934',
    info: '#83A598',
    gradient: 'linear-gradient(135deg, #FE8019, #FABD2F)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  cobalt2: {
    name: 'Cobalt2',
    primary: '#FFC600',
    secondary: '#FF9D00',
    accent: '#FB94FF',
    background: '#193549',
    surface: '#15232D',
    surfaceHover: '#1d3345',
    border: '#2a4d6b',
    text: '#FFFFFF',
    textPrimary: '#FFFFFF',
    textSecondary: '#A1C3D1',
    textMuted: '#5F8AA5',
    textDark: '#FFFFFF',
    cardBg: '#15232D',
    cardBorder: '#2a4d6b',
    sidebarBg: '#0D2137',
    sidebarActive: '#FFC600',
    sidebarText: '#5F8AA5',
    inputBg: '#0D2137',
    inputBorder: '#2a4d6b',
    inputFocus: '#FFC600',
    buttonPrimary: '#FFC600',
    buttonPrimaryHover: '#e0ad00',
    buttonSecondary: '#2a4d6b',
    buttonText: '#193549',
    success: '#3AD900',
    warning: '#FFC600',
    error: '#FF628C',
    info: '#80FCFF',
    gradient: 'linear-gradient(135deg, #FFC600, #FF9D00)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.35)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.45)',
    isDark: true
  },
  ayuMirage: {
    name: 'Ayu Mirage',
    primary: '#FFAD66',
    secondary: '#F28779',
    accent: '#5CCFE6',
    background: '#1F2430',
    surface: '#242936',
    surfaceHover: '#2c3140',
    border: '#33415E',
    text: '#CCCAC2',
    textPrimary: '#CCCAC2',
    textSecondary: '#B8B4AA',
    textMuted: '#5C6773',
    textDark: '#CCCAC2',
    cardBg: '#242936',
    cardBorder: '#33415E',
    sidebarBg: '#1F2430',
    sidebarActive: '#FFAD66',
    sidebarText: '#5C6773',
    inputBg: '#1F2430',
    inputBorder: '#33415E',
    inputFocus: '#FFAD66',
    buttonPrimary: '#FFAD66',
    buttonPrimaryHover: '#e09550',
    buttonSecondary: '#33415E',
    buttonText: '#1F2430',
    success: '#BAE67E',
    warning: '#FFD580',
    error: '#FF3333',
    info: '#5CCFE6',
    gradient: 'linear-gradient(135deg, #FFAD66, #F28779)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  rosePine: {
    name: 'Rosé Pine',
    primary: '#C4A7E7',
    secondary: '#EBBCBA',
    accent: '#F6C177',
    background: '#191724',
    surface: '#1F1D2E',
    surfaceHover: '#26233A',
    border: '#403D52',
    text: '#E0DEF4',
    textPrimary: '#E0DEF4',
    textSecondary: '#908CAA',
    textMuted: '#6E6A86',
    textDark: '#E0DEF4',
    cardBg: '#1F1D2E',
    cardBorder: '#403D52',
    sidebarBg: '#191724',
    sidebarActive: '#C4A7E7',
    sidebarText: '#6E6A86',
    inputBg: '#191724',
    inputBorder: '#403D52',
    inputFocus: '#C4A7E7',
    buttonPrimary: '#C4A7E7',
    buttonPrimaryHover: '#b090d5',
    buttonSecondary: '#403D52',
    buttonText: '#191724',
    success: '#9CCFD8',
    warning: '#F6C177',
    error: '#EB6F92',
    info: '#31748F',
    gradient: 'linear-gradient(135deg, #C4A7E7, #EBBCBA)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.35)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.45)',
    isDark: true
  },
  vitesseDark: {
    name: 'Vitesse Dark',
    primary: '#4D9375',
    secondary: '#80A665',
    accent: '#C98A7D',
    background: '#121212',
    surface: '#1E1E1E',
    surfaceHover: '#252525',
    border: '#2E2E2E',
    text: '#DBD7CA',
    textPrimary: '#DBD7CA',
    textSecondary: '#B8B5AA',
    textMuted: '#666666',
    textDark: '#DBD7CA',
    cardBg: '#1E1E1E',
    cardBorder: '#2E2E2E',
    sidebarBg: '#121212',
    sidebarActive: '#4D9375',
    sidebarText: '#666666',
    inputBg: '#121212',
    inputBorder: '#2E2E2E',
    inputFocus: '#4D9375',
    buttonPrimary: '#4D9375',
    buttonPrimaryHover: '#3d7a60',
    buttonSecondary: '#2E2E2E',
    buttonText: '#ffffff',
    success: '#80A665',
    warning: '#E6CC77',
    error: '#CB7676',
    info: '#6394BF',
    gradient: 'linear-gradient(135deg, #4D9375, #80A665)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.5)',
    isDark: true
  },
  nightOwl: {
    name: 'Night Owl',
    primary: '#7FDBCA',
    secondary: '#C792EA',
    accent: '#82AAFF',
    background: '#011627',
    surface: '#0B2942',
    surfaceHover: '#112d4e',
    border: '#1D3B53',
    text: '#D6DEEB',
    textPrimary: '#D6DEEB',
    textSecondary: '#B0BEC5',
    textMuted: '#637777',
    textDark: '#D6DEEB',
    cardBg: '#0B2942',
    cardBorder: '#1D3B53',
    sidebarBg: '#011627',
    sidebarActive: '#7FDBCA',
    sidebarText: '#637777',
    inputBg: '#011627',
    inputBorder: '#1D3B53',
    inputFocus: '#7FDBCA',
    buttonPrimary: '#7FDBCA',
    buttonPrimaryHover: '#5fc4b1',
    buttonSecondary: '#1D3B53',
    buttonText: '#011627',
    success: '#ADDB67',
    warning: '#ECC48D',
    error: '#EF5350',
    info: '#82AAFF',
    gradient: 'linear-gradient(135deg, #7FDBCA, #C792EA)',
    shadow: '0 2px 8px rgba(1, 22, 39, 0.4)',
    shadowHover: '0 4px 16px rgba(1, 22, 39, 0.5)',
    isDark: true
  },
  // ═══════════════════════════════════════════════════
  // NEW THEMES (17)
  // ═══════════════════════════════════════════════════
  materialOcean: {
    name: 'Material Ocean',
    primary: '#82AAFF',
    secondary: '#C792EA',
    accent: '#FFCB6B',
    background: '#0F111A',
    surface: '#1A1C25',
    surfaceHover: '#222430',
    border: '#2B2F3A',
    text: '#B0BEC5',
    textPrimary: '#EEFFFF',
    textSecondary: '#B0BEC5',
    textMuted: '#546E7A',
    textDark: '#EEFFFF',
    cardBg: '#1A1C25',
    cardBorder: '#2B2F3A',
    sidebarBg: '#0F111A',
    sidebarActive: '#82AAFF',
    sidebarText: '#546E7A',
    inputBg: '#0F111A',
    inputBorder: '#2B2F3A',
    inputFocus: '#82AAFF',
    buttonPrimary: '#82AAFF',
    buttonPrimaryHover: '#6E96E8',
    buttonSecondary: '#2B2F3A',
    buttonText: '#0F111A',
    success: '#C3E88D',
    warning: '#FFCB6B',
    error: '#FF5370',
    info: '#89DDFF',
    gradient: 'linear-gradient(135deg, #82AAFF, #C792EA)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.5)',
    isDark: true
  },
  palenight: {
    name: 'Palenight',
    primary: '#82AAFF',
    secondary: '#C792EA',
    accent: '#F78C6C',
    background: '#292D3E',
    surface: '#32374C',
    surfaceHover: '#3A3F55',
    border: '#444966',
    text: '#A6ACCD',
    textPrimary: '#BABED8',
    textSecondary: '#A6ACCD',
    textMuted: '#676E95',
    textDark: '#BABED8',
    cardBg: '#32374C',
    cardBorder: '#444966',
    sidebarBg: '#292D3E',
    sidebarActive: '#82AAFF',
    sidebarText: '#676E95',
    inputBg: '#292D3E',
    inputBorder: '#444966',
    inputFocus: '#82AAFF',
    buttonPrimary: '#82AAFF',
    buttonPrimaryHover: '#6E96E8',
    buttonSecondary: '#444966',
    buttonText: '#292D3E',
    success: '#C3E88D',
    warning: '#FFCB6B',
    error: '#FF5370',
    info: '#89DDFF',
    gradient: 'linear-gradient(135deg, #82AAFF, #C792EA)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  horizon: {
    name: 'Horizon',
    primary: '#E95678',
    secondary: '#FAB795',
    accent: '#25B0BC',
    background: '#1C1E26',
    surface: '#232530',
    surfaceHover: '#2B2D3A',
    border: '#3D3F4E',
    text: '#CBCED0',
    textPrimary: '#FADAD1',
    textSecondary: '#CBCED0',
    textMuted: '#6C6F93',
    textDark: '#FADAD1',
    cardBg: '#232530',
    cardBorder: '#3D3F4E',
    sidebarBg: '#1C1E26',
    sidebarActive: '#E95678',
    sidebarText: '#6C6F93',
    inputBg: '#1C1E26',
    inputBorder: '#3D3F4E',
    inputFocus: '#E95678',
    buttonPrimary: '#E95678',
    buttonPrimaryHover: '#D4405F',
    buttonSecondary: '#3D3F4E',
    buttonText: '#ffffff',
    success: '#29D398',
    warning: '#FAC29A',
    error: '#E95678',
    info: '#26BBD9',
    gradient: 'linear-gradient(135deg, #E95678, #FAB795)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.35)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.45)',
    isDark: true
  },
  everforestDark: {
    name: 'Everforest Dark',
    primary: '#A7C080',
    secondary: '#D699B6',
    accent: '#E69875',
    background: '#2D353B',
    surface: '#343F44',
    surfaceHover: '#3D484D',
    border: '#475258',
    text: '#D3C6AA',
    textPrimary: '#D3C6AA',
    textSecondary: '#BDB79B',
    textMuted: '#7A8478',
    textDark: '#D3C6AA',
    cardBg: '#343F44',
    cardBorder: '#475258',
    sidebarBg: '#2D353B',
    sidebarActive: '#A7C080',
    sidebarText: '#7A8478',
    inputBg: '#2D353B',
    inputBorder: '#475258',
    inputFocus: '#A7C080',
    buttonPrimary: '#A7C080',
    buttonPrimaryHover: '#93AD6D',
    buttonSecondary: '#475258',
    buttonText: '#2D353B',
    success: '#A7C080',
    warning: '#DBBC7F',
    error: '#E67E80',
    info: '#7FBBB3',
    gradient: 'linear-gradient(135deg, #A7C080, #7FBBB3)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  everforestLight: {
    name: 'Everforest Light',
    primary: '#8DA101',
    secondary: '#DF69BA',
    accent: '#F57D26',
    background: '#FDF6E3',
    surface: '#F4F0D9',
    surfaceHover: '#EBE7CC',
    border: '#D5CDB6',
    text: '#5C6A72',
    textPrimary: '#5C6A72',
    textSecondary: '#708089',
    textMuted: '#939F91',
    textDark: '#3C474D',
    cardBg: '#FFFBEF',
    cardBorder: '#D5CDB6',
    sidebarBg: '#F4F0D9',
    sidebarActive: '#8DA101',
    sidebarText: '#939F91',
    inputBg: '#FFFBEF',
    inputBorder: '#D5CDB6',
    inputFocus: '#8DA101',
    buttonPrimary: '#8DA101',
    buttonPrimaryHover: '#7A8C01',
    buttonSecondary: '#EBE7CC',
    buttonText: '#ffffff',
    success: '#8DA101',
    warning: '#DFA000',
    error: '#F85552',
    info: '#3A94C5',
    gradient: 'linear-gradient(135deg, #8DA101, #35A77C)',
    shadow: '0 2px 8px rgba(92, 106, 114, 0.08)',
    shadowHover: '0 4px 16px rgba(92, 106, 114, 0.12)',
    isDark: false
  },
  kanagawa: {
    name: 'Kanagawa',
    primary: '#7E9CD8',
    secondary: '#957FB8',
    accent: '#DCA561',
    background: '#1F1F28',
    surface: '#2A2A37',
    surfaceHover: '#363646',
    border: '#54546D',
    text: '#DCD7BA',
    textPrimary: '#DCD7BA',
    textSecondary: '#C8C093',
    textMuted: '#727169',
    textDark: '#DCD7BA',
    cardBg: '#2A2A37',
    cardBorder: '#54546D',
    sidebarBg: '#1F1F28',
    sidebarActive: '#7E9CD8',
    sidebarText: '#727169',
    inputBg: '#1F1F28',
    inputBorder: '#54546D',
    inputFocus: '#7E9CD8',
    buttonPrimary: '#7E9CD8',
    buttonPrimaryHover: '#6A88C4',
    buttonSecondary: '#54546D',
    buttonText: '#1F1F28',
    success: '#76946A',
    warning: '#DCA561',
    error: '#C34043',
    info: '#7FB4CA',
    gradient: 'linear-gradient(135deg, #7E9CD8, #957FB8)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.35)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.45)',
    isDark: true
  },
  atomOneLight: {
    name: 'Atom One Light',
    primary: '#4078F2',
    secondary: '#A626A4',
    accent: '#E45649',
    background: '#FAFAFA',
    surface: '#F0F0F0',
    surfaceHover: '#E5E5E5',
    border: '#DBDBDC',
    text: '#383A42',
    textPrimary: '#383A42',
    textSecondary: '#696C77',
    textMuted: '#A0A1A7',
    textDark: '#232426',
    cardBg: '#FFFFFF',
    cardBorder: '#DBDBDC',
    sidebarBg: '#F0F0F0',
    sidebarActive: '#4078F2',
    sidebarText: '#A0A1A7',
    inputBg: '#FFFFFF',
    inputBorder: '#DBDBDC',
    inputFocus: '#4078F2',
    buttonPrimary: '#4078F2',
    buttonPrimaryHover: '#3468D8',
    buttonSecondary: '#E5E5E5',
    buttonText: '#ffffff',
    success: '#50A14F',
    warning: '#C18401',
    error: '#E45649',
    info: '#4078F2',
    gradient: 'linear-gradient(135deg, #4078F2, #A626A4)',
    shadow: '0 2px 8px rgba(56, 58, 66, 0.06)',
    shadowHover: '0 4px 16px rgba(56, 58, 66, 0.1)',
    isDark: false
  },
  andromeda: {
    name: 'Andromeda',
    primary: '#EE5D43',
    secondary: '#C74DED',
    accent: '#00E8C6',
    background: '#23262E',
    surface: '#292C36',
    surfaceHover: '#313440',
    border: '#3B3F4C',
    text: '#D5CED9',
    textPrimary: '#F7F7F8',
    textSecondary: '#D5CED9',
    textMuted: '#7E7A86',
    textDark: '#F7F7F8',
    cardBg: '#292C36',
    cardBorder: '#3B3F4C',
    sidebarBg: '#23262E',
    sidebarActive: '#EE5D43',
    sidebarText: '#7E7A86',
    inputBg: '#23262E',
    inputBorder: '#3B3F4C',
    inputFocus: '#EE5D43',
    buttonPrimary: '#EE5D43',
    buttonPrimaryHover: '#D94830',
    buttonSecondary: '#3B3F4C',
    buttonText: '#ffffff',
    success: '#96E072',
    warning: '#FFE66D',
    error: '#EE5D43',
    info: '#00E8C6',
    gradient: 'linear-gradient(135deg, #EE5D43, #C74DED)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  pandaSyntax: {
    name: 'Panda Syntax',
    primary: '#19F9D8',
    secondary: '#FF75B5',
    accent: '#FFB86C',
    background: '#292A2B',
    surface: '#31353A',
    surfaceHover: '#3B4048',
    border: '#4B5059',
    text: '#E6E6E6',
    textPrimary: '#E6E6E6',
    textSecondary: '#CDCDCD',
    textMuted: '#757575',
    textDark: '#E6E6E6',
    cardBg: '#31353A',
    cardBorder: '#4B5059',
    sidebarBg: '#292A2B',
    sidebarActive: '#19F9D8',
    sidebarText: '#757575',
    inputBg: '#292A2B',
    inputBorder: '#4B5059',
    inputFocus: '#19F9D8',
    buttonPrimary: '#19F9D8',
    buttonPrimaryHover: '#10D9BB',
    buttonSecondary: '#4B5059',
    buttonText: '#292A2B',
    success: '#19F9D8',
    warning: '#FFB86C',
    error: '#FF2C6D',
    info: '#45A9F9',
    gradient: 'linear-gradient(135deg, #19F9D8, #FF75B5)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.3)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.4)',
    isDark: true
  },
  shadesOfPurple: {
    name: 'Shades of Purple',
    primary: '#FAD000',
    secondary: '#FF628C',
    accent: '#A5FF90',
    background: '#2D2B55',
    surface: '#1E1E3F',
    surfaceHover: '#3A3875',
    border: '#4D4B88',
    text: '#A599E9',
    textPrimary: '#FFFFFF',
    textSecondary: '#A599E9',
    textMuted: '#7B71B7',
    textDark: '#FFFFFF',
    cardBg: '#1E1E3F',
    cardBorder: '#4D4B88',
    sidebarBg: '#2D2B55',
    sidebarActive: '#FAD000',
    sidebarText: '#7B71B7',
    inputBg: '#1E1E3F',
    inputBorder: '#4D4B88',
    inputFocus: '#FAD000',
    buttonPrimary: '#FAD000',
    buttonPrimaryHover: '#E0B800',
    buttonSecondary: '#4D4B88',
    buttonText: '#2D2B55',
    success: '#A5FF90',
    warning: '#FAD000',
    error: '#FF628C',
    info: '#9EFFFF',
    gradient: 'linear-gradient(135deg, #FAD000, #FF628C)',
    shadow: '0 2px 8px rgba(45, 43, 85, 0.4)',
    shadowHover: '0 4px 16px rgba(45, 43, 85, 0.5)',
    isDark: true
  },
  winterIsComing: {
    name: 'Winter Is Coming',
    primary: '#82AAFF',
    secondary: '#C792EA',
    accent: '#89DDFF',
    background: '#011627',
    surface: '#0B2942',
    surfaceHover: '#10324F',
    border: '#1B4965',
    text: '#D6DEEB',
    textPrimary: '#D6DEEB',
    textSecondary: '#B0BEC5',
    textMuted: '#5F7E97',
    textDark: '#D6DEEB',
    cardBg: '#0B2942',
    cardBorder: '#1B4965',
    sidebarBg: '#011627',
    sidebarActive: '#82AAFF',
    sidebarText: '#5F7E97',
    inputBg: '#011627',
    inputBorder: '#1B4965',
    inputFocus: '#82AAFF',
    buttonPrimary: '#82AAFF',
    buttonPrimaryHover: '#6E96E8',
    buttonSecondary: '#1B4965',
    buttonText: '#011627',
    success: '#22DA6E',
    warning: '#ADDB67',
    error: '#EF5350',
    info: '#82AAFF',
    gradient: 'linear-gradient(135deg, #82AAFF, #C792EA)',
    shadow: '0 2px 8px rgba(1, 22, 39, 0.5)',
    shadowHover: '0 4px 16px rgba(1, 22, 39, 0.6)',
    isDark: true
  },
  moonlight: {
    name: 'Moonlight',
    primary: '#82AAFF',
    secondary: '#C099FF',
    accent: '#FFC777',
    background: '#222436',
    surface: '#2F334D',
    surfaceHover: '#383C58',
    border: '#444A73',
    text: '#C8D3F5',
    textPrimary: '#C8D3F5',
    textSecondary: '#B4C2F0',
    textMuted: '#636DA6',
    textDark: '#C8D3F5',
    cardBg: '#2F334D',
    cardBorder: '#444A73',
    sidebarBg: '#222436',
    sidebarActive: '#82AAFF',
    sidebarText: '#636DA6',
    inputBg: '#222436',
    inputBorder: '#444A73',
    inputFocus: '#82AAFF',
    buttonPrimary: '#82AAFF',
    buttonPrimaryHover: '#6E96E8',
    buttonSecondary: '#444A73',
    buttonText: '#222436',
    success: '#C3E88D',
    warning: '#FFC777',
    error: '#FF757F',
    info: '#86E1FC',
    gradient: 'linear-gradient(135deg, #82AAFF, #C099FF)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.35)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.45)',
    isDark: true
  },
  vesper: {
    name: 'Vesper',
    primary: '#FFC799',
    secondary: '#E6B673',
    accent: '#D4976C',
    background: '#101010',
    surface: '#1C1C1C',
    surfaceHover: '#252525',
    border: '#333333',
    text: '#B7B7B7',
    textPrimary: '#FFFFFF',
    textSecondary: '#B7B7B7',
    textMuted: '#6B6B6B',
    textDark: '#FFFFFF',
    cardBg: '#1C1C1C',
    cardBorder: '#333333',
    sidebarBg: '#101010',
    sidebarActive: '#FFC799',
    sidebarText: '#6B6B6B',
    inputBg: '#101010',
    inputBorder: '#333333',
    inputFocus: '#FFC799',
    buttonPrimary: '#FFC799',
    buttonPrimaryHover: '#E6B080',
    buttonSecondary: '#333333',
    buttonText: '#101010',
    success: '#6BAA75',
    warning: '#FFC799',
    error: '#D1615F',
    info: '#6EB4BF',
    gradient: 'linear-gradient(135deg, #FFC799, #D4976C)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.6)',
    isDark: true
  },
  slackAubergine: {
    name: 'Slack Aubergine',
    primary: '#1264A3',
    secondary: '#E01E5A',
    accent: '#36C5F0',
    background: '#1A1D21',
    surface: '#222529',
    surfaceHover: '#2C2F33',
    border: '#383B3F',
    text: '#D1D2D3',
    textPrimary: '#D1D2D3',
    textSecondary: '#ABABAD',
    textMuted: '#616061',
    textDark: '#D1D2D3',
    cardBg: '#222529',
    cardBorder: '#383B3F',
    sidebarBg: '#19171D',
    sidebarActive: '#1264A3',
    sidebarText: '#616061',
    inputBg: '#1A1D21',
    inputBorder: '#383B3F',
    inputFocus: '#1264A3',
    buttonPrimary: '#007A5A',
    buttonPrimaryHover: '#006B4F',
    buttonSecondary: '#383B3F',
    buttonText: '#ffffff',
    success: '#007A5A',
    warning: '#ECB22E',
    error: '#E01E5A',
    info: '#36C5F0',
    gradient: 'linear-gradient(135deg, #611f69, #4A154B)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.4)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.5)',
    isDark: true
  },
  spotify: {
    name: 'Spotify',
    primary: '#1DB954',
    secondary: '#1ED760',
    accent: '#B3B3B3',
    background: '#121212',
    surface: '#181818',
    surfaceHover: '#282828',
    border: '#333333',
    text: '#B3B3B3',
    textPrimary: '#FFFFFF',
    textSecondary: '#B3B3B3',
    textMuted: '#727272',
    textDark: '#FFFFFF',
    cardBg: '#181818',
    cardBorder: '#333333',
    sidebarBg: '#000000',
    sidebarActive: '#1DB954',
    sidebarText: '#727272',
    inputBg: '#2A2A2A',
    inputBorder: '#333333',
    inputFocus: '#1DB954',
    buttonPrimary: '#1DB954',
    buttonPrimaryHover: '#1AA34A',
    buttonSecondary: '#333333',
    buttonText: '#000000',
    success: '#1DB954',
    warning: '#F59B23',
    error: '#E91429',
    info: '#509BF5',
    gradient: 'linear-gradient(135deg, #1DB954, #191414)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.5)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.6)',
    isDark: true
  },
  notionLight: {
    name: 'Notion',
    primary: '#2383E2',
    secondary: '#EB5757',
    accent: '#0F7B6C',
    background: '#FFFFFF',
    surface: '#F7F6F3',
    surfaceHover: '#EDEDEB',
    border: '#E3E2DE',
    text: '#37352F',
    textPrimary: '#37352F',
    textSecondary: '#6B6B6B',
    textMuted: '#9B9A97',
    textDark: '#37352F',
    cardBg: '#FFFFFF',
    cardBorder: '#E3E2DE',
    sidebarBg: '#F7F6F3',
    sidebarActive: '#2383E2',
    sidebarText: '#9B9A97',
    inputBg: '#FFFFFF',
    inputBorder: '#E3E2DE',
    inputFocus: '#2383E2',
    buttonPrimary: '#2383E2',
    buttonPrimaryHover: '#1C6DBF',
    buttonSecondary: '#EDEDEB',
    buttonText: '#ffffff',
    success: '#0F7B6C',
    warning: '#CB912F',
    error: '#EB5757',
    info: '#2383E2',
    gradient: 'linear-gradient(135deg, #2383E2, #EB5757)',
    shadow: '0 2px 8px rgba(55, 53, 47, 0.05)',
    shadowHover: '0 4px 16px rgba(55, 53, 47, 0.08)',
    isDark: false
  },
  arcDark: {
    name: 'Arc Dark',
    primary: '#5294E2',
    secondary: '#A37ACC',
    accent: '#4DC69B',
    background: '#383C4A',
    surface: '#404552',
    surfaceHover: '#4B5162',
    border: '#4F5566',
    text: '#D3DAE3',
    textPrimary: '#D3DAE3',
    textSecondary: '#BAC3CF',
    textMuted: '#7C818C',
    textDark: '#D3DAE3',
    cardBg: '#404552',
    cardBorder: '#4F5566',
    sidebarBg: '#2F343F',
    sidebarActive: '#5294E2',
    sidebarText: '#7C818C',
    inputBg: '#383C4A',
    inputBorder: '#4F5566',
    inputFocus: '#5294E2',
    buttonPrimary: '#5294E2',
    buttonPrimaryHover: '#4080CC',
    buttonSecondary: '#4F5566',
    buttonText: '#ffffff',
    success: '#4DC69B',
    warning: '#F5C211',
    error: '#FC4138',
    info: '#5294E2',
    gradient: 'linear-gradient(135deg, #5294E2, #A37ACC)',
    shadow: '0 2px 8px rgba(0, 0, 0, 0.25)',
    shadowHover: '0 4px 16px rgba(0, 0, 0, 0.35)',
    isDark: true
  }
};

const ThemeContext = createContext();

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within ThemeProvider');
  }
  return context;
};

// Helper: generate a full theme object from 5 base colors
export function generateThemeFromPalette(name, colors, isDark = true) {
  // colors: { primary, secondary, accent, background, surface }
  const bg = colors.background;
  const sf = colors.surface;
  const pr = colors.primary;
  const sc = colors.secondary;
  const ac = colors.accent;

  // Auto-derive text colors based on background luminance
  const lum = parseInt(bg.replace('#', ''), 16);
  const isActuallyDark = (((lum >> 16) & 0xff) * 0.299 + ((lum >> 8) & 0xff) * 0.587 + (lum & 0xff) * 0.114) < 128;
  const textMain = isActuallyDark ? '#E0E0E0' : '#1F2328';
  const textSec = isActuallyDark ? '#B0B0B0' : '#656D76';
  const textMut = isActuallyDark ? '#707070' : '#8C959F';

  // Derive border from surface
  const borderR = Math.min(255, parseInt(sf.substring(1, 3), 16) + (isActuallyDark ? 20 : -20));
  const borderG = Math.min(255, parseInt(sf.substring(3, 5), 16) + (isActuallyDark ? 20 : -20));
  const borderB = Math.min(255, parseInt(sf.substring(5, 7), 16) + (isActuallyDark ? 20 : -20));
  const border = `#${borderR.toString(16).padStart(2, '0')}${borderG.toString(16).padStart(2, '0')}${borderB.toString(16).padStart(2, '0')}`;

  // Hover surface
  const hoverR = Math.min(255, parseInt(sf.substring(1, 3), 16) + (isActuallyDark ? 12 : -8));
  const hoverG = Math.min(255, parseInt(sf.substring(3, 5), 16) + (isActuallyDark ? 12 : -8));
  const hoverB = Math.min(255, parseInt(sf.substring(5, 7), 16) + (isActuallyDark ? 12 : -8));
  const surfaceHover = `#${hoverR.toString(16).padStart(2, '0')}${hoverG.toString(16).padStart(2, '0')}${hoverB.toString(16).padStart(2, '0')}`;

  return {
    name,
    primary: pr,
    secondary: sc,
    accent: ac,
    background: bg,
    surface: sf,
    surfaceHover,
    border,
    text: textMain,
    textPrimary: textMain,
    textSecondary: textSec,
    textMuted: textMut,
    textDark: textMain,
    cardBg: sf,
    cardBorder: border,
    sidebarBg: bg,
    sidebarActive: pr,
    sidebarText: textMut,
    inputBg: bg,
    inputBorder: border,
    inputFocus: pr,
    buttonPrimary: pr,
    buttonPrimaryHover: sc,
    buttonSecondary: border,
    buttonText: isActuallyDark ? '#ffffff' : '#ffffff',
    success: isActuallyDark ? '#4ade80' : '#16a34a',
    warning: isActuallyDark ? '#fbbf24' : '#d97706',
    error: isActuallyDark ? '#f87171' : '#dc2626',
    info: ac,
    gradient: `linear-gradient(135deg, ${pr}, ${sc})`,
    shadow: isActuallyDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.08)',
    shadowHover: isActuallyDark ? '0 4px 16px rgba(0,0,0,0.4)' : '0 4px 16px rgba(0,0,0,0.12)',
    isDark: isActuallyDark,
    isCustom: true
  };
}

export const ThemeProvider = ({ children }) => {
  const [currentTheme, setCurrentTheme] = useState(() => {
    const saved = localStorage.getItem('impulse-theme');
    if (saved === 'default' || !saved) {
      localStorage.setItem('impulse-theme', 'impulse');
      return 'impulse';
    }
    return saved;
  });

  // Custom user themes from localStorage
  const [customThemes, setCustomThemes] = useState(() => {
    try {
      const saved = localStorage.getItem('impulse-custom-themes');
      return saved ? JSON.parse(saved) : {};
    } catch (_) { return {}; }
  });

  useEffect(() => {
    localStorage.setItem('impulse-theme', currentTheme);
  }, [currentTheme]);

  useEffect(() => {
    localStorage.setItem('impulse-custom-themes', JSON.stringify(customThemes));
  }, [customThemes]);

  // Merge built-in + custom themes
  const allThemes = { ...themes, ...customThemes };
  const theme = allThemes[currentTheme] || themes.impulse;

  const addCustomTheme = (key, themeObj) => {
    setCustomThemes(prev => ({ ...prev, [key]: { ...themeObj, isCustom: true } }));
  };

  const removeCustomTheme = (key) => {
    setCustomThemes(prev => {
      const next = { ...prev };
      delete next[key];
      return next;
    });
    if (currentTheme === key) setCurrentTheme('impulse');
  };

  const value = {
    currentTheme,
    setCurrentTheme,
    theme,
    themes: allThemes,
    builtInThemes: themes,
    customThemes,
    addCustomTheme,
    removeCustomTheme
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};
